import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { UTV_2_DAY_PROMO_AVAILABLE_DATES_YEAR } from 'views/rebranded-module/OffRoadToursLandingViewV2/utils/constants';

const useOffRoadToursLandingCMSData = () => {
  const { t } = useTranslation();

  const data = useMemo(
    () => ({
      data: {
        OffRoadLandingPage: {
          // Hero section
          heroTitle: t('off_road_tour_landing_page:hero_title'),
          heroSubTitle: t('off_road_tour_landing_page:hero_desc'),
          heroVideo: {
            small_url: {
              url: '/videos/offRoadHero.webm',
            },
            large_url: {
              url: '/videos/offRoadHero.mp4',
            },
            fallbackImage: '/videos/fallbackImgs/OffRoadPromoSection.jpg',
            alt: 'off-Road Adventure',
          },
          patternBackground: {
            small_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            medium_url: {
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            large_url: {
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            alt: 'pattern Background',
          },
          utvPromoPatternBackground: {
            small_url: {
              url: '/imgs/Rebranding/petterns/rock-texture-dark-bg.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/petterns/rock-texture-dark-bg.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/petterns/rock-texture-dark-bg.jpg',
            },
            alt: 'Rock texture pattern background',
          },
          utvPromoTourBackground: {
            small_url: {
              url: '/imgs/Rebranding/off-road/OffRoadUTVPromo-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/off-road/OffRoadUTVPromo-md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/off-road/OffRoadUTVPromo-lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/off-road/OffRoadUTVPromo-lg.jpg',
            },
            alt: 'Off-Road UTV promo tour',
          },
          utvPromoTitleLine1: t('off_road_tour_landing_page:utv_promo_title_line1'),
          utvPromoTitleAccent: t(
            'off_road_tour_landing_page:utv_promo_title_accent',
          ),
          utvPromoTitleLine2: t('off_road_tour_landing_page:utv_promo_title_line2'),
          utvPromoDescription: t('off_road_tour_landing_page:utv_promo_desc'),
          utvPromoSpotsLimited: t(
            'off_road_tour_landing_page:utv_promo_spots_limited',
          ),
          utvPromoAvailableDatesHeading: t(
            'off_road_tour_landing_page:utv_promo_available_dates_heading',
            { year: UTV_2_DAY_PROMO_AVAILABLE_DATES_YEAR },
          ),
          // Labels
          learnMoreBtnLabel: t('off_road_tour_landing_page:learn_more'),
          bookTourBtnLabel: t('off_road_tour_landing_page:book_tour'),
          utvBookNowBtnLabel: t('off_road_tour_landing_page:utv_book_now_btn'),

          // hightlights section
          highLightsTitle: t('off_road_tour_landing_page:hightlights_title'),
          highLightsDescription: t(
            'off_road_tour_landing_page:hightlights_Description',
          ),
          highLightsList: [
            {
              title: t('off_road_tour_landing_page:hightlight_1_title'),
              description: t('off_road_tour_landing_page:hightlight_1_desc', {
                returnObjects: true,
              }) as string[],
            },
            {
              title: t('off_road_tour_landing_page:hightlight_2_title'),
              description: t('off_road_tour_landing_page:hightlight_2_desc', {
                returnObjects: true,
              }) as string[],
            },
            {
              title: t('off_road_tour_landing_page:hightlight_3_title'),
              description: t('off_road_tour_landing_page:hightlight_3_desc', {
                returnObjects: true,
              }) as string[],
            },
          ],
          // Advanture Section
          adventureTourType: 'off-road-tours',
          adventureSlug: 'las-vegas-mojave-desert-off-road-tour',
          adventureTitle: t('off_road_tour_landing_page:ready_to_experience'),
          adventureDescription: t(
            'off_road_tour_landing_page:tour_experience_desc',
          ),
          advantureBackground: {
            small_url: {
              url: '/imgs/Rebranding/off-road/ready-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/off-road/ready-md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/off-road/ready-xl.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/off-road/ready-xl.jpg',
            },
            alt: 'advanture Background',
          },
          // Advanture experince section
          adventuresTitle: t('off_road_tour_landing_page:rugged_adventure'),
          adventuresDescription: t(
            'off_road_tour_landing_page:eagleRider_off_road_way',
          ),
          adventuresDescriptionList: [
            { benefitText: t('off_road_tour_landing_page:benfit_1') },
            { benefitText: t('off_road_tour_landing_page:benfit_2') },
            { benefitText: t('off_road_tour_landing_page:benfit_3') },
            { benefitText: t('off_road_tour_landing_page:benfit_4') },
            { benefitText: t('off_road_tour_landing_page:benfit_5') },
          ],
          adventuresExprienceBackground: {
            small_url: {
              url: '/imgs/Rebranding/off-road/advanture-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/off-road/advanture-md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/off-road/advanture-lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/off-road/advanture-lg.jpg',
            },
            alt: 'adventures Expprience Background',
          },
          adventuresExprienceSubBackground: {
            small_url: {
              url: '/imgs/Rebranding/off-road/sub-advanture-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/off-road/sub-advanture-lg.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/off-road/sub-advanture-lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/off-road/sub-advanture-lg.jpg',
            },
            alt: 'adventures Expprience sub Background',
          },
          // Fleet section
          fleetTitle: t('off_road_tour_landing_page:our_fleet'),
          fleetDescription: t(
            'off_road_tour_landing_page:prepare_unparalleled',
          ),
          fleetBtn: t('off_road_tour_landing_page:book_now'),
          fleetList: [
            { benefitText: t('off_road_tour_landing_page:option_1') },
            { benefitText: t('off_road_tour_landing_page:option_2') },
            { benefitText: t('off_road_tour_landing_page:option_3') },
          ],

          // Testimonials
          testimonialsTitle: t('off_road_tour_landing_page:testimonials'),
          testimonialsDescription: t(
            'off_road_tour_landing_page:what_your_fellow_adventurers_say',
          ),
          testimonials: [
            {
              title: t('off_road_tour_landing_page:testimonials_title_1'),
              comment: t('off_road_tour_landing_page:testimonials_comment_1'),
              name: t('off_road_tour_landing_page:testimonials_name_1'),
            },
            {
              title: t('off_road_tour_landing_page:testimonials_title_2'),
              comment: t('off_road_tour_landing_page:testimonials_comment_2'),
              name: t('off_road_tour_landing_page:testimonials_name_2'),
            },
            {
              title: t('off_road_tour_landing_page:testimonials_title_3'),
              comment: t('off_road_tour_landing_page:testimonials_comment_3'),
              name: t('off_road_tour_landing_page:testimonials_name_3'),
            },
          ],
          testimonialsBackground: {
            small_url: {
              url: '/imgs/Rebranding/off-road/Testimonials-sm.jpg',
            },
            medium_url: {
              url: '/imgs/Rebranding/off-road/Testimonials-md.jpg',
            },
            large_url: {
              url: '/imgs/Rebranding/off-road/Testimonials-lg.jpg',
            },
            xlarge_url: {
              url: '/imgs/Rebranding/off-road/Testimonials-xl.jpg',
            },
            alt: 'advanture Background',
          },
          // popular OffRoad Tours
          popularOffRoadToursTitle: t(
            'off_road_tour_landing_page:popular_off_road_tours',
          ),
          popularOffRoadToursDescription: t(
            'off_road_tour_landing_page:popular_off_road_tours_desc',
          ),

          distanceDisplay: t('off_road_tour_landing_page:distance_display'),
          arrival: t('off_road_tour_landing_page:arrival'),
          tempDisplay: t('off_road_tour_landing_page:temp'),
          promoDescription: t('off_road_tour_landing_page:promo_desc'),
        },
        TourCardComponent: {
          dayCount: t('common_tour_card:days'),
          miCount: t('common_tour_card:mi'),
          startingAt: t('common_tour_card:start_at'),
          kmCount: t('common_tour_card:km'),
        },
        GalleryComponent: {
          showAllMedia: t('common_gallery:show_photos'),
        },
      },
    }),
    [t],
  );

  return data;
};

export { useOffRoadToursLandingCMSData };
